var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.556,
    height: 200,
    viewBox: "0 0 284.556 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-302.013 -2640)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    d: "M3.848,271.942H8.884c3.037,0,6.074-.718,6.074-4.556s-3.037-4.554-6.074-4.554H3.848ZM.013,259.475H9.962c7.234,0,9.07,4.355,9.07,7.911a7.584,7.584,0,0,1-6.951,7.474l8.031,12.905h-4.8L8.126,275.3H3.848v12.465H.013v-28.29Z",
    transform: "translate(302 2551.515)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    d: "M44.955,259.475h18.26v3.595H48.79V271.5H62.215v3.6H48.79v9.072H63.935v3.595H44.955v-28.29",
    transform: "translate(286.782 2551.515)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-36",
    d: "M89.547,281.484a7.058,7.058,0,0,0,5.992,3.038c2.519,0,5.635-1.6,5.635-4.716,0-6.513-13.945-2.476-13.945-13.506,0-3.319,2.8-7.911,9.59-7.911,3.074,0,6.033.64,8.151,3.236l-3.117,2.838a5.93,5.93,0,0,0-5.034-2.479c-4.238,0-5.515,2.558-5.515,4.316,0,7.152,13.945,2.875,13.945,13.066,0,5.474-4.4,8.75-9.831,8.75-3.636,0-7.111-1.239-9.029-3.917l3.157-2.716",
    transform: "translate(272.689 2551.883)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    d: "M131.513,287.765h3.835v-28.29h-3.835Z",
    transform: "translate(257.382 2551.515)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-38",
    d: "M159.208,284.17h4.835c6.473,0,11.986-3.558,11.986-10.552,0-3.595-1.876-10.549-11.066-10.549h-5.755Zm-3.835-24.7h9.869c11.948,0,14.866,8.91,14.866,14.143,0,7.234-5.4,14.146-15.505,14.146h-9.23v-28.29Z",
    transform: "translate(249.277 2551.515)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    d: "M209.132,259.475h18.262v3.595H212.967V271.5h13.425v3.6H212.967v9.072h15.145v3.595h-18.98v-28.29",
    transform: "translate(231.037 2551.515)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-40",
    d: "M254.073,259.475h5.035l15.584,23.256h.08V259.475h3.835v28.29h-4.875l-15.743-23.256h-.08v23.256h-3.835v-28.29",
    transform: "translate(215.782 2551.515)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    d: "M328.987,265.22a8.7,8.7,0,0,0-6.832-3.236c-6.353,0-10.549,5.076-10.549,11.508,0,5.954,3.956,11.031,10.549,11.031a8.716,8.716,0,0,0,7.391-3.8l3.236,2.438a13.161,13.161,0,0,1-10.709,4.954,14.565,14.565,0,0,1-14.543-14.625c0-8.791,6.033-15.1,14.744-15.1,3.715,0,7.632,1.4,9.91,4.394l-3.2,2.437",
    transform: "translate(197.641 2551.883)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-42",
    d: "M360.745,259.475h18.262v3.595H364.58V271.5h13.426v3.6H364.58v9.072h15.145v3.595h-18.98v-28.29",
    transform: "translate(179.558 2551.515)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    d: "M405.339,281.484a7.06,7.06,0,0,0,5.993,3.038c2.519,0,5.636-1.6,5.636-4.716,0-6.513-13.946-2.476-13.946-13.506,0-3.319,2.8-7.911,9.59-7.911,3.078,0,6.033.64,8.151,3.236l-3.116,2.838a5.929,5.929,0,0,0-5.035-2.479c-4.237,0-5.515,2.558-5.515,4.316,0,7.152,13.946,2.875,13.946,13.066,0,5.474-4.4,8.75-9.832,8.75-3.634,0-7.111-1.239-9.028-3.917l3.155-2.716",
    transform: "translate(165.527 2551.883)",
    fill: "#4d4e4c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-44",
    d: "M267.664.63c-12,0-21.753,10.277-21.753,22.917,0,12.616,9.754,22.913,21.753,22.913,11.98,0,21.729-10.3,21.729-22.913,0-12.64-9.749-22.917-21.729-22.917",
    transform: "translate(218.538 2639.37)",
    fill: "#f5ba2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-45",
    d: "M210.741,64.131H158.685a6.93,6.93,0,0,1-6.367-7.083c9.517,0,35.954.044,58.423,0Zm0,69.427H158.685v-.016a6.912,6.912,0,0,1-6.367-7.084c9.517,0,35.954.054,58.423,0Zm0-55.534H158.685L158.7,78a6.918,6.918,0,0,1-6.385-7.083c9.517,0,35.954.036,58.423,0Zm0,13.879H158.685l.018-.013a6.917,6.917,0,0,1-6.385-7.066c9.517,0,35.954.039,58.423,0Zm0,13.888H158.7a6.942,6.942,0,0,1-6.385-7.083c9.517,0,35.954.035,58.423,0Zm0,13.883H158.7a6.95,6.95,0,0,1-6.385-7.1c9.517,0,35.954.054,58.423,0v7.1Z",
    transform: "translate(250.297 2620.204)",
    fill: "#1f649f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-46",
    d: "M240.651,47.971,261.2,30.241,240.651,55.054Zm0,69.41L261.2,99.656l-20.553,24.825Zm0-55.536Q250.952,53,261.2,44.126q-10.272,12.393-20.553,24.821Zm0,13.9L261.2,58.01q-10.272,12.4-20.553,24.816Zm0,13.884c6.867-5.927,13.7-11.816,20.553-17.737q-10.272,12.4-20.553,24.82ZM261.2,85.767Q250.932,98.186,240.651,110.6v-7.1c6.867-5.911,13.7-11.793,20.553-17.731Z",
    transform: "translate(220.34 2629.344)",
    fill: "#2789bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    d: "M128.91,217.75a2.644,2.644,0,0,1-.874.811,2.951,2.951,0,0,1-1.087.382c-.407.032-.755.071-1.031.071h-2.929v-5.477h2.929a8.155,8.155,0,0,1,1.064.085,3.611,3.611,0,0,1,1.09.431,2.376,2.376,0,0,1,.851.832,2.848,2.848,0,0,1,.321,1.368A2.915,2.915,0,0,1,128.91,217.75Zm-5.921-12.008h2.667a4.4,4.4,0,0,1,.938.113,2.435,2.435,0,0,1,.892.372,2.023,2.023,0,0,1,.624.732,2.33,2.33,0,0,1,.245,1.157,2.2,2.2,0,0,1-.245,1.128,2.032,2.032,0,0,1-.608.741,2.419,2.419,0,0,1-.857.377,3.485,3.485,0,0,1-.989.136h-2.667Zm9.836,13.472a5.631,5.631,0,0,0,.515-2.566,4.876,4.876,0,0,0-.393-2.04,4.619,4.619,0,0,0-.984-1.419,4.7,4.7,0,0,0-1.226-.9,6.725,6.725,0,0,0-1.169-.412l-.511-.119.511-.136a4.044,4.044,0,0,0,.8-.363,3.749,3.749,0,0,0,.915-.806,5.654,5.654,0,0,0,.749-1.234,3.873,3.873,0,0,0,.323-1.626,6.078,6.078,0,0,0-.343-1.921,3.962,3.962,0,0,0-1.076-1.615,5.305,5.305,0,0,0-1.949-1.128,8.535,8.535,0,0,0-2.926-.423h-7v19.713h7a13.087,13.087,0,0,0,3.03-.306,6.06,6.06,0,0,0,2.285-.989,4.3,4.3,0,0,0,1.447-1.709Z",
    transform: "translate(261.604 2570.86)",
    fill: "#121718",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-48",
    d: "M151.222,205.84h2.865a2.709,2.709,0,0,1,2.015.77,3.045,3.045,0,0,1,.74,2.11,2.83,2.83,0,0,1-.74,2.05,2.576,2.576,0,0,1-2.015.792h-2.865Zm6.268,16.379h4.286l-4.157-7.929.177-.1a6.1,6.1,0,0,0,2.236-2.247,7.006,7.006,0,0,0,.784-3.335,6.933,6.933,0,0,0-.4-2.37,5.258,5.258,0,0,0-1.221-1.945,5.49,5.49,0,0,0-2.04-1.3,8.165,8.165,0,0,0-2.86-.487H147.4v19.713h3.824v-7.386h2.7l3.568,7.386Z",
    transform: "translate(251.988 2570.86)",
    fill: "#121718",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-49",
    d: "M175.406,222.218h3.937V202.505h-3.937Z",
    transform: "translate(242.488 2570.86)",
    fill: "#121718",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-50",
    d: "M205.793,211.287h-6.965v3.283H202.2v2.837l-.073.054a4.539,4.539,0,0,1-1.738.948,7.155,7.155,0,0,1-2.153.3,5.81,5.81,0,0,1-2.332-.469,5.365,5.365,0,0,1-1.894-1.315,6.02,6.02,0,0,1-1.244-2.087,7.847,7.847,0,0,1-.458-2.706,9,9,0,0,1,.385-2.546,6.987,6.987,0,0,1,1.118-2.13,5.934,5.934,0,0,1,1.8-1.434,5.71,5.71,0,0,1,2.452-.545,5.164,5.164,0,0,1,2.816.757,8.547,8.547,0,0,1,1.914,1.77l2.656-2.682a8.693,8.693,0,0,0-3.1-2.595,10.3,10.3,0,0,0-8.391-.205,9.127,9.127,0,0,0-3.06,2.2,9.746,9.746,0,0,0-1.995,3.3,11.713,11.713,0,0,0-.7,4.109,12.973,12.973,0,0,0,.659,4.2,9.217,9.217,0,0,0,1.919,3.258,8.781,8.781,0,0,0,3.067,2.085,10.347,10.347,0,0,0,4.122.77,13.18,13.18,0,0,0,4.479-.721,10.229,10.229,0,0,0,3.34-2.013v-8.423",
    transform: "translate(238.138 2571.122)",
    fill: "#121718",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    d: "M228.818,206.555l2.489,7.918h-5.024Zm3.474,11.042,1.47,4.621h4.126l-6.668-19.713H226.44l-6.808,19.713h4.212l1.438-4.621Z",
    transform: "translate(227.474 2570.86)",
    fill: "#121718",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    d: "M264.43,216.957a6.166,6.166,0,0,1-4.542,1.612h-2.832V206.11h2.832a7.523,7.523,0,0,1,2.734.451,5.1,5.1,0,0,1,3.056,3.3,8.953,8.953,0,0,1,.353,2.6A6.268,6.268,0,0,1,264.43,216.957Zm4.964-.228a10.983,10.983,0,0,0,.757-4.251,12.234,12.234,0,0,0-.75-4.5,8.054,8.054,0,0,0-5.238-4.881,12.8,12.8,0,0,0-4-.6h-7.023v19.713h6.988a12.78,12.78,0,0,0,4-.6A8.513,8.513,0,0,0,267.3,219.8a8.258,8.258,0,0,0,2.1-3.066Z",
    transform: "translate(216.106 2570.86)",
    fill: "#121718",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    d: "M289.85,218.607v-4.749h5.832l.859-3.46H289.85v-4.314h7.77l.88-3.579H285.89v19.713h11.73l.88-3.612h-8.65",
    transform: "translate(204.995 2570.86)",
    fill: "#121718",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrlogo);
export default __webpack_public_path__ + "static/media/BRLOGO.316ecfc74c6a3ca4315cdb388cde0ca5.svg";
export { ForwardRef as ReactComponent };